module.exports = __webpack_public_path__ + "static/vigvamLogo-afa9f20896e6a4f1f628b396058054c9.png";